<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-file code="cv" :file="sasEquivalence.curriculumVitae" :live="liveSasEquivalence(3812)" optional></opq-file>
    <opq-file-multiple code="fichiers-divers" :files="sasEquivalence.fichiersDivers" :live="liveSasEquivalence(3813)" optional></opq-file-multiple>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-permis-psychologue-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  }
}
</script>

<style>
</style>